module.exports = __webpack_public_path__ + "img/HOTEL.203ca5e8.png";